module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('banner', {
    attrs: {
      "data": _vm.banners
    }
  }), _vm._v(" "), _c('floating'), _vm._v(" "), _c('div', {
    staticClass: "section-container production"
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "production__show"
  }, [_c('ul', {
    staticClass: "clearfix show__box"
  }, _vm._l((_vm.sceneList), function(item, index) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!(_vm.isMoreShow && index > 3)),
        expression: "!(isMoreShow&&index>3)"
      }],
      key: item.id,
      staticClass: "show__item"
    }, [_c('div', {
      staticClass: "show__top",
      on: {
        "click": function($event) {
          _vm.onSceneClick(item)
        }
      }
    }, [_c('div', {
      staticClass: "show__img"
    }, [_c('img', {
      attrs: {
        "src": item.picUrl,
        "alt": item.name
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "show__desc"
    }, [_c('h3', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.remark))])])]), _vm._v(" "), _c('div', {
      staticClass: "show__bottom"
    }, [_c('div', {
      staticClass: "small__line"
    }), _vm._v(" "), _c('span', [_c('i'), _vm._v(_vm._s(index < 10 ? '0' + (index + 1) : index + 1))])])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sceneList && _vm.sceneList.length > 4),
      expression: "sceneList && sceneList.length > 4"
    }],
    staticClass: "more__box",
    staticStyle: {
      "padding-bottom": "20px",
      "height": "40px"
    }
  }, [_c('a', {
    staticClass: "more",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.isMoreShow = !_vm.isMoreShow
      }
    }
  }, [_vm._v(_vm._s(_vm.isMoreShow ? '[ 更多 ]' : '[ 收起 ]'))])])]), _vm._v(" "), _c('div', {
    staticClass: "production__recommend"
  }, [_c('h2', {
    staticClass: "area-title"
  }, [_vm._v("产品介绍")]), _vm._v(" "), _c('borrowList', {
    attrs: {
      "data-list": _vm.productionList
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productionList && _vm.productionList.length >= 3),
      expression: "productionList && productionList.length>=3"
    }],
    staticClass: "more__box"
  }, [_c('a', {
    staticClass: "more",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/borrow')
      }
    }
  }, [_vm._v("[ 更多 ]")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "section-contianer consultants"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.consultants.length !== 0),
      expression: "consultants.length !== 0"
    }],
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "consultants__show"
  }, [_c('h2', {
    staticClass: "area-title"
  }, [_vm._v("业务咨询")]), _vm._v(" "), _c('div', {
    staticClass: "counserlorSwiper"
  }, [_c('swiper', {
    ref: "consultantsSwiper",
    attrs: {
      "is-pagination": _vm.consultantsIsPagination,
      "pagination": 'consultants__pagination',
      "calculateHeight": true,
      "navigation": false,
      "autoplay": _vm.consultantsAutoplay,
      "loop": _vm.consultantsLoop,
      "slides-per-view": 3,
      "on-touch-start": _vm.consultantTouchStart,
      "on-touch-end": _vm.consultantTouchEnd
    }
  }, _vm._l((_vm.consultants), function(item, index) {
    return _c('swiper-item', {
      key: index
    }, [_c('div', {
      staticClass: "consultants__item"
    }, [_c('div', {
      staticClass: "consultants__item-box clearfix",
      attrs: {
        "counselorId": item.uid
      }
    }, [_c('div', {
      staticClass: "consultants__img"
    }, [_c('img', {
      attrs: {
        "src": item.logoUrl,
        "alt": item.name
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "consultants__desc"
    }, [_c('div', {
      staticClass: "consultants__name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "consultants__job"
    }, [_vm._v(_vm._s(item.profession))]), _vm._v(" "), _c('div', {
      staticClass: "consultants__phone"
    }, [_c('span', {
      staticClass: "iconfont phone"
    }, [_vm._v("")]), _vm._v("：" + _vm._s(_vm.prefix(item.phone)))]), _vm._v(" "), _c('div', {
      staticClass: "consultants__wechat"
    }, [_c('span', {
      staticClass: "iconfont wechat"
    }, [_vm._v("")]), _vm._v("：" + _vm._s(item.wechat))]), _vm._v(" "), _c('div', {
      staticClass: "consultants__order"
    }, [_vm._v("立即预约")])])])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "more__box",
    staticStyle: {
      "padding-bottom": "0",
      "height": "20px",
      "margin-top": "-10px"
    }
  }, [_c('a', {
    staticClass: "more",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/consultant/counserlor')
      }
    }
  }, [_vm._v(_vm._s('[ 更多 ]'))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "articles"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAritcles),
      expression: "showAritcles"
    }],
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "articles__recommend"
  }, [_c('h2', {
    staticClass: "area-title"
  }, [_vm._v("文章推荐")]), _vm._v(" "), _c('typebar', {
    attrs: {
      "loan-type-arr": _vm.loanTypeArr,
      "selected-index": _vm.selectedLoanTypeIndex
    },
    on: {
      "on-item-click": _vm.onTypeChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "articles-list"
  }, [_c('datagrid', {
    attrs: {
      "articleList": _vm.articleList
    },
    on: {
      "on-item-click": _vm.onItemClick
    }
  })], 1), _vm._v(" "), _c('Loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleList && _vm.articleList.length === 0),
      expression: "articleList && articleList.length === 0"
    }],
    attrs: {
      "height": 100,
      "is-no-more": _vm.articleListNoMore
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "more__box"
  }, [_c('a', {
    staticClass: "more",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/consultant/case-share')
      }
    }
  }, [_vm._v("[ 更多 ]")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.partnerPictureList.length !== 0),
      expression: "partnerPictureList.length !== 0"
    }],
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "cooperator"
  }, [_c('h2', {
    staticClass: "area-title"
  }, [_vm._v("合作单位")]), _vm._v(" "), _c('div', {
    staticClass: "cooperator-list clearfix"
  }, _vm._l((_vm.partnerPictureList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cooperator-item"
    }, [_c('a', {
      staticClass: "cooperator-img",
      attrs: {
        "href": item.linkAddress,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": item.picturePath,
        "alt": item.partnerName
      }
    })])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "attention__us"
  }, [_c('h2', {
    staticClass: "area-title"
  }, [_vm._v("关注我们")]), _vm._v(" "), _c('div', {
    staticClass: "row row-bottom text-center"
  }, [_c('a', {
    staticClass: "col-xs-4 list",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goWechat
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('a', {
    staticClass: "col-xs-4 list",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goWebsite
    }
  }, [_vm._m(3), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _vm._m(5)])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "advertising"
  }, [_c('div', {
    staticClass: "advertising-wrap"
  }, [_c('div', {
    staticClass: "close_wrap pull-right",
    on: {
      "click": function($event) {
        _vm.isShow = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/advertising-close.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "advertising-text"
  }, [_c('div', {
    staticClass: "advertising-text-wrap pull-left"
  }, [_c('p', {
    staticStyle: {
      "font-size": "40px"
    }
  }, [_vm._v("伟 嘉 安 捷 客 服 电 话")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "25px"
    }
  }, [_vm._v("服 务 时 间 ： " + _vm._s(_vm.custServiceTime[0] && _vm.custServiceTime[0].customerServiceTime))])]), _vm._v(" "), _c('div', {
    staticClass: "advertising-tel-wrap pull-left"
  }, [_c('p', {
    staticStyle: {
      "font-size": "76px"
    }
  }, [_vm._v(_vm._s(_vm.remarks))])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "consultants__bg"
  }, [_c('div', {
    staticClass: "consultats__shadow"
  }), _vm._v(" "), _c('div', {
    staticClass: "consultants__anglebox"
  }, [_c('div', {
    staticClass: "consultants__anglebox__left"
  }), _vm._v(" "), _c('div', {
    staticClass: "consultants__anglebg"
  }), _vm._v(" "), _c('div', {
    staticClass: "consultants__anglebox__right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": "/static/img/wechat-qrcode.png",
      "alt": "",
      "width": "160"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-caption"
  }, [_c('h3', {
    staticClass: "caption"
  }, [_vm._v("伟嘉安捷官方微信")]), _vm._v(" "), _c('div', {
    staticClass: "point"
  }), _vm._v(" "), _c('p', {
    staticClass: "bottom"
  }, [_vm._v("搜索公众号"), _c('span', [_vm._v("“伟嘉安捷”")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": "/static/img/website-qrcode.png",
      "alt": "",
      "width": "160"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-caption"
  }, [_c('h3', {
    staticClass: "caption"
  }, [_vm._v("伟嘉安捷手机官网")]), _vm._v(" "), _c('div', {
    staticClass: "point"
  }), _vm._v(" "), _c('p', {
    staticClass: "bottom"
  }, [_vm._v("提供一站式贷款服务")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "col-xs-4 list",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('span', [_c('img', {
    attrs: {
      "src": "/static/img/app-qrcode.png",
      "alt": "",
      "width": "160"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "page-caption"
  }, [_c('h3', {
    staticClass: "caption"
  }, [_vm._v("伟嘉安捷官方APP")]), _vm._v(" "), _c('div', {
    staticClass: "point"
  }), _vm._v(" "), _c('p', {
    staticClass: "bottom"
  }, [_vm._v("专业房产金融服务App")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-ccf85fc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/home.vue
// module id = 624
// module chunks = 1